import modalsReducer from "modules/modals/reducer";

const reducers = {
  modals: modalsReducer,
};

export default reducers;
